export default {
    reset(){
        localStorage.removeItem('9manad_appointment_new_station_code')
    }
    ,getStationCode() {
        return localStorage.getItem('9manad_appointment_new_station_code')
    }
    ,setStationCode(station_code){
        localStorage.setItem('9manad_appointment_new_station_code',station_code)
    }

    ,setStationShortDetail(shortdetail){
        localStorage.setItem('9manad_appointment_new_logo',shortdetail.logo)
        localStorage.setItem('9manad_appointment_new_banner',shortdetail.banner)
        localStorage.setItem('9manad_appointment_new_station_name',shortdetail.station_name)
    }
    ,getStationName() {
        return localStorage.getItem('9manad_appointment_new_station_name')
    }
    ,getLogo() {
        return localStorage.getItem('9manad_appointment_new_logo')
    }
    ,getBanner() {
        return localStorage.getItem('9manad_appointment_new_banner')
    }

    ,getGroupId() {
        return localStorage.getItem('9manad_appointment_new_group_id')
    }
    ,setGroupId(group_id){
        localStorage.setItem('9manad_appointment_new_group_id',group_id)
    }

    ,getDate() {
        return localStorage.getItem('9manad_appointment_new_date')
    }
    ,setDate(date){
        localStorage.setItem('9manad_appointment_new_date',date)
    }

    ,getTime() {
        return [localStorage.getItem('9manad_appointment_new_timestart'),localStorage.getItem('9manad_appointment_new_timeend')]
    }
    ,setTime(timestart,timeend){
        localStorage.setItem('9manad_appointment_new_timestart',timestart)
        localStorage.setItem('9manad_appointment_new_timeend',timeend)
    }

    ,getExtranote() {
        return localStorage.getItem('9manad_appointment_new_extranote')
    }
    ,setExtranote(extranote){
        localStorage.setItem('9manad_appointment_new_extranote',extranote)
    }

    ,getExtranoteValue() {
        return localStorage.getItem('9manad_appointment_new_extranote_value')
    }
    ,setExtranoteValue(extranote){
        localStorage.setItem('9manad_appointment_new_extranote_value',extranote)
    }

    ,getAddfriendUrl() {
        return localStorage.getItem('9manad_addfriendurl')
    }
    ,setAddfriendUrl(url){
        localStorage.setItem('9manad_addfriendurl',url)
    }

}